import React from "react";

interface Props {
  color?: string;
  size?: number;
}
export default function SortingFilterIcon({
  color = "#79808A",
  size = 20,
}: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 11.8755L13.75 15.8332L17.5 11.8755M10 8.02102L6.25 4.1665M6.25 4.1665L2.5 8.01813M6.25 4.1665V15.7301M13.75 4.1665V15.7301"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
